function setFlexItemWidth(columns) {
    const gap = 10;
    const flexItems = document.querySelectorAll('.oct-quiz-products__item');
    const width = `calc(${100 / columns}% - ${gap}px)`;
  
    flexItems.forEach((item) => {
      item.style.flex = `0 0 ${width}`;
    });
  }
  
  function adjustFlexItemWidth() {
    const viewportWidth = window.innerWidth;
    const maxColumns = viewportWidth < 768 ? 2 : 4;
  
    setFlexItemWidth(maxColumns);
  
    return true;
  }
  
  function setOutOfStockText() {
    const textNode = document.createTextNode("Out of Stock");
    const targetDiv = document.querySelector("div.km-darkgrey");
  
    if (targetDiv && !targetDiv.classList.contains('out-of-stock-appended')) {
      targetDiv.appendChild(textNode);
      targetDiv.classList.add('out-of-stock-appended'); 
      return true;
    }
  }
  
  let intervalId = setInterval(() => {
    if (window.innerWidth <= 768) {
      const progress1OutOf4 = document.querySelector('img[alt="progress-bar-1-4"]');
      const progress2OutOf4 = document.querySelector('img[alt="progress-bar-2-4"]');
      const progress3OutOf4 = document.querySelector('img[alt="progress-bar-3-4"]');
      const progress4OutOf4 = document.querySelector('img[alt="progress-bar-4-4"]');
  
      const progress1OutOf5 = document.querySelector('img[alt="progress-bar-1-5"]');
      const progress2OutOf5 = document.querySelector('img[alt="progress-bar-2-5"]');
      const progress3OutOf5 = document.querySelector('img[alt="progress-bar-3-5"]');
      const progress4OutOf5 = document.querySelector('img[alt="progress-bar-4-5"]');
      const progress5OutOf5 = document.querySelector('img[alt="progress-bar-5-5"]');
  
      const progress1OutOf6 = document.querySelector('img[alt="progress-bar-1-6"]');
      const progress2OutOf6 = document.querySelector('img[alt="progress-bar-2-6"]');
      const progress3OutOf6 = document.querySelector('img[alt="progress-bar-3-6"]');
      const progress4OutOf6 = document.querySelector('img[alt="progress-bar-4-6"]');
      const progress5OutOf6 = document.querySelector('img[alt="progress-bar-5-6"]');
      const progress6OutOf6 = document.querySelector('img[alt="progress-bar-6-6"]');
  
      switch(true){
  
        //1-4
        case !!progress1OutOf4:
          progress1OutOf4.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q1_of_4.jpg?v=1679078084';
          break;
        case !!progress2OutOf4:
          progress2OutOf4.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q2_of_4.jpg?v=1679078637';
          break;
        case !!progress3OutOf4:
          progress3OutOf4.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q3_of_4.jpg?v=1679078637';
          break;
        case !!progress4OutOf4:
          progress4OutOf4.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q4_of_4.jpg?v=1679078637';
          break;
        
        //1-5
        case !!progress1OutOf5:
          progress1OutOf5.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q1_of_5.jpg?v=1679079816';
          break;
        case !!progress2OutOf5:
          progress2OutOf5.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q2_of_5.jpg?v=1679078637';
          break;
        case !!progress3OutOf5:
          progress3OutOf5.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q3_of_5.jpg?v=1679078637';
          break;
        case !!progress4OutOf5:
          progress4OutOf5.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q4_of_5.jpg?v=1679078637';
          break;
        case !!progress5OutOf5:
          progress5OutOf5.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q5_of_5.jpg?v=1679078637';
          break;
  
        //1-6
        case !!progress1OutOf6:
          progress1OutOf6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q1_of_6.jpg?v=1679080058';
          break;
        case !!progress2OutOf6:
          progress2OutOf6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q2_of_6.jpg?v=1679078637';
          break;
        case !!progress3OutOf6:
          progress3OutOf6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q3_of_6.jpg?v=1679078637';
          break;
        case !!progress4OutOf6:
          progress4OutOf6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q4_of_6.jpg?v=1679078637';
          break;
        case !!progress5OutOf6:
          progress5OutOf6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q5_of_6.jpg?v=1679078637';
          break;
        case !!progress6OutOf6:
          progress6OutOf6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/q6_of_6.jpg?v=1679078637';
          break;
      }
   }
  
    const resultPageWrapper = document.querySelector('.oct-quiz-wrapper--result-page');
  
    if (resultPageWrapper) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
  
      const adjustFlexWidthResult = adjustFlexItemWidth();
      const outOfStockTextResult = setOutOfStockText();
  
      if (window.innerWidth <= 768) {
  
      const resultBanner1 = document.querySelector('img[alt="result-banner-1"]');
      const resultBanner2 = document.querySelector('img[alt="result-banner-2"]');
      const resultBanner3 = document.querySelector('img[alt="result-banner-3"]');
      const resultBanner4 = document.querySelector('img[alt="result-banner-4"]');
      const resultBanner5 = document.querySelector('img[alt="result-banner-5"]');
      const resultBanner6 = document.querySelector('img[alt="result-banner-6"]');
      const resultBanner7 = document.querySelector('img[alt="result-banner-7"]');
      const resultBanner8 = document.querySelector('img[alt="result-banner-8"]');
      const resultBanner9 = document.querySelector('img[alt="result-banner-9"]');
      const resultBanner10 = document.querySelector('img[alt="result-banner-10"]');
      const resultBanner11 = document.querySelector('img[alt="result-banner-11"]');
      const resultBanner12 = document.querySelector('img[alt="result-banner-12"]');
      const resultBanner13 = document.querySelector('img[alt="result-banner-13"]');
      const resultBanner14 = document.querySelector('img[alt="result-banner-14"]');
      const resultBanner15 = document.querySelector('img[alt="result-banner-15"]');
      const resultBanner16 = document.querySelector('img[alt="result-banner-16"]');
      const resultBanner17 = document.querySelector('img[alt="result-banner-17"]');
      const resultBanner18 = document.querySelector('img[alt="result-banner-18"]');
      const resultBanner19 = document.querySelector('img[alt="result-banner-19"]');
      
      const customerReview = document.querySelector('img[alt="customer-review"]');
      const evolvedIndustry = document.querySelector('img[alt="evolved-industry"]');
    
      switch (true) {
        case !!resultBanner1:
            resultBanner1.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/strug_add_musc-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner2:
            resultBanner2.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/diff_leaning-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner3:
            resultBanner3.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/lacking_intense-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner4:
            resultBanner4.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/less_than_2-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner5:
            resultBanner5.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/3_to_5-mobile.jpg?v=1679064419';
            
            break;
        case !!resultBanner6:
            resultBanner6.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/6_to_8-mobile.jpg?v=1679064419';
            
            break;
        case !!resultBanner7:
            resultBanner7.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/6_to_8-mobile.jpg?v=1679064419';
            
          break; 
        case !!resultBanner8:
            resultBanner8.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/diff_finishing_workouts-mobile.jpg?v=1679064419';
            
          break;    
        case !!resultBanner9:
            resultBanner9.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/very_sore_male_not_enough_sleep-mobile.jpg?v=1679064419';
            
          break; 
        case !!resultBanner10:
            resultBanner10.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/Sore_between_workouts_enough_sleep-mobile.jpg?v=1679064419';
            
          break; 
        case !!resultBanner11:
            resultBanner11.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/Lose_weight_keep_off_Male-mobile.jpg?v=1679064419';
            
          break;    
        case !!resultBanner12:
            resultBanner12.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/knowing_right_nutrition-mobile.jpg?v=1679064419';
            
          break; 
        case !!resultBanner13:
            resultBanner13.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/enough_to_see_changesMale-mobile.jpg?v=1679064420';
            
          break; 
        case !!resultBanner14:
            resultBanner14.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/focus_AM-mobile.jpg?v=1679064419';
            
          break; 
        case !!resultBanner15:
            resultBanner15.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/Focus_PM-mobile.jpg?v=1679064420';
            
          break;
        case !!resultBanner16:
            resultBanner16.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/Focus_Evening-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner17:
            resultBanner17.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/very_sore_male_not_enough_sleep-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner18:
            resultBanner18.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/very_sore_male_not_enough_sleep-mobile.jpg?v=1679064419';
            
          break;
        case !!resultBanner19:
            resultBanner19.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/Wellbeing-mobile.jpg?v=1679064419';
            
          break;
      }
  
      if (customerReview) {
        customerReview.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/reviews-mobile.jpg?v=1679072589';
      }
      
      if (evolvedIndustry) {
        evolvedIndustry.src = 'https://cdn.shopify.com/s/files/1/1110/3248/files/Highlights-mobile.jpg?v=1679072589';
      }
    
      if (resultPageWrapper && customerReview && evolvedIndustry) {
        clearInterval(intervalId);
      } else if (adjustFlexWidthResult && outOfStockTextResult) {
        clearInterval(intervalId);
      }
  
    }
    } else {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    }
  
  }, 500);